<template>
  <v-btn
    :color="color"
    outlined
    rounded
    @click="click"
    class="ma-1"
  >
    <v-icon left dark>{{ icon }}</v-icon>
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  name: "LocationAttributeSwitch",
  props: {
    text: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: null
    }
  },
  data: () => ({
    icon: 'mdi-plus',
    color: 'primary',
    myValue: null
  }),
  created() {
    this.myValue = this.value

    if (this.value === true) {
      this.icon = 'mdi-check'
      this.color = 'success'
    } else if (this.value === false) {
      this.icon = 'mdi-block-helper'
      this.color = 'error'
    } else if (this.value === null) {
      this.icon = 'mdi-plus'
      this.color = 'primary'
    }
  },
  methods: {
    change: function() {
      this.$emit('change', this.myValue)
    },
    click: function() {
      if (this.myValue === null) {
        this.myValue = true
        this.icon = 'mdi-check'
        this.color = 'success'
      } else if (this.myValue === true) {
        this.myValue = false
        this.icon = 'mdi-block-helper'
        this.color = 'error'
      } else if (this.myValue === false) {
        this.myValue = null
        this.icon = 'mdi-plus'
        this.color = 'primary'
      }
      this.change()
    }
  }
}
</script>

<style scoped>

</style>